import deviation from "../deviation";

export default function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/threshold/scott.js
// module id = ./node_modules/d3-array/src/threshold/scott.js
// module chunks = vendor